<template>
  <BContainer
    class="p-0"
    fluid
  >
    <form
      role="form"
      novalidate
      @submit.prevent
    >
      <BRow>
        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Student ID"
            label-for="fIdNumber"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fIdNumber"
              v-model="formUser.id_number"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="First Name"
            label-for="fFirstName"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fFirstName"
              v-model="formUser.first_name"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Middle Name"
            label-for="fMiddleName"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fMiddleName"
              v-model="formUser.middle_name"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Last Name"
            label-for="fLastName"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fLastName"
              v-model="formUser.last_name"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Extension Name"
            label-for="fExtensionName"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fExtensionName"
              v-model="formUser.extension_name"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol cols="12" />

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Course"
            label-for="fCourse"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fCourse"
              v-model="formUser.course"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Year Level"
            label-for="fYearLevel"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fYearLevel"
              v-model="formUser.year_level"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol cols="12" />

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Email"
            label-for="fEmail"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fEmail"
              v-model="formUser.email"
              disabled
            />
          </BFormGroup>
        </BCol>

        <BCol
          cols="12"
          md="4"
        >
          <BFormGroup
            label="Contact Number"
            label-for="fContactNumber"
            label-class="font-weight-bolder"
            class="mb-2"
          >
            <BFormInput
              id="fContactNumber"
              v-model="formUser.contact_number"
              disabled
            />
          </BFormGroup>
        </BCol>
      </BRow>
    </form>
  </BContainer>
</template>

<script>
export default {
  name: 'VStudentInformations',

  props: {
    user: {
      type: Object,
      default: () => ({
        id: '',
        id_number: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        extension_name: '',
        course: '',
        year_level: '',
        email: '',
        contact_number: ''
      })
    }
  },

  data () {
    return {
      formUser: {
        id_number: this.user.id_number,
        first_name: this.user.first_name,
        middle_name: this.user.middle_name,
        last_name: this.user.last_name,
        extension_name: this.user.extension_name,
        course: this.user.course,
        year_level: this.user.year_level,
        email: this.user.email,
        contact_number: this.user.contact_number
      }
    }
  }
}
</script>
